import React from "react";
import {
  Card,
  Popconfirm,
  Row,
  Col,
  Spin,
  Empty,
  Pagination,
  Badge,
  Select,
  Carousel,
  Image,
} from "antd";
import {
  EditOutlined,
  DeleteFilled,
  EyeTwoTone,
  HomeOutlined,
  CheckCircleOutlined,
  EnvironmentOutlined,
  TagOutlined,
} from "@ant-design/icons";
import { propertyStatusHandler } from "../../utils/property-status";
import { numberSeprator } from "../../utils/number-seprator";
import PropertyPlaceholder from "../../assets/dashboard/propertyPlaceholder.png";

const Faq = ({
  confirm,
  properties,
  currentPage,
  setCurrentPage,
  loader,
  selectedRecord,
  navigate,
  getPropertyHandler,
  cancel,
  setLimit,
  limit,
}) => {
  const { Meta } = Card;

  return (
    <React.Fragment>
      {loader ? (
        <div className="spin_information">
          <Spin />
        </div>
      ) : properties?.properties?.length > 0 ? (
        <div>
          <div className="faq_content">
            <div>
              <Row gutter={24} scroll={{ x: 1023 }}>
                {properties?.properties?.map((data, index) => (
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={8}
                    xxl={6}
                    key={index}
                    className="common-box-properties"
                  >
                    {/* Sold Out */}
                    {data?.soldOut && (
                      <Badge
                        count={
                          data?.propertyStatusMessage
                            ? data?.propertyStatusMessage
                            : propertyStatusHandler(data?.status)
                        }
                        className="tag1"
                      />
                    )}
                    {data?.propertyLabel && (
                      <Badge
                        count={data?.propertyLabel}
                        className={data?.soldOut ? "tag2" : ""}
                      />
                    )}
                    <Card
                      cover={
                        data?.images?.length > 0 ? (
                          <>
                            <Carousel>
                              {data?.images?.splice(0, 8)?.map((img, index) => (
                                <div key={index}>
                                  <Image
                                    src={img?.url}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = PropertyPlaceholder;
                                    }}
                                    style={{ borderBottom: "1px solid #eee" }}
                                    alt="example"
                                    className="card-image"
                                  />
                                </div>
                              ))}
                            </Carousel>
                          </>
                        ) : (
                          <Image
                            height={320}
                            src={PropertyPlaceholder}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = PropertyPlaceholder;
                            }}
                            style={{ borderBottom: "1px solid #eee" }}
                            alt="example"
                            className="card-image"
                          />
                        )
                      }
                      actions={[
                        <a
                          href={`https://empireinfratech.ae/property-details/${data?.slug}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <EyeTwoTone />
                        </a>,
                        <EditOutlined
                          key="edit"
                          className="delete-icon-admin cursor-pointer "
                          onClick={() =>
                            navigate("/edit-property/" + data?._id)
                          }
                        />,
                        data?._id === selectedRecord ? (
                          <Spin />
                        ) : (
                          <Popconfirm
                            title="Delete the Project"
                            description="Are you sure to delete this Project?"
                            onConfirm={() => confirm(data)}
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <DeleteFilled className="delete-icon-admin cursor-pointer" />
                          </Popconfirm>
                        ),
                      ]}
                    >
                      <Meta
                        title={
                          <div className="truncate-title-one title">
                            {data?.title}
                          </div>
                        }
                        description={
                          <div className="truncate-title-one description-container">
                            <div className="address mb">
                              <div>
                                <CheckCircleOutlined />
                                <span>{data?.status}</span>
                              </div>
                              <div className="status">
                                <HomeOutlined />
                                <span>{data?.type}</span>
                              </div>
                            </div>
                            <div className="address mb">
                              <div>
                                <EnvironmentOutlined />
                                <span>{data?.address}</span>
                              </div>
                              <div className="status">
                                <TagOutlined />
                                <span>
                                  {numberSeprator(data?.saleOrRentprice)}
                                </span>
                              </div>
                            </div>
                          </div>
                        }
                        className="margin-bottom-card"
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
            {!loader && (
              <div className="pagination-container">
                <Pagination
                  defaultPageSize={currentPage}
                  showSizeChanger={false}
                  current={currentPage}
                  pageSize={limit}
                  total={properties?.totalPropertys}
                  onChange={(e) => {
                    setCurrentPage(e);
                    getPropertyHandler(e);
                  }}
                  className="pagination"
                />
                <Select
                  options={[
                    { value: 10, label: "Page limit 10" },
                    { value: 20, label: "Page limit 20" },
                    { value: 30, label: "Page limit 30" },
                    { value: 40, label: "Page limit 40" },
                    { value: 50, label: "Page limit 50" },
                  ]}
                  value={limit}
                  onChange={(e) => {
                    setLimit(e);
                    setCurrentPage(1);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="no-data">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            className="spin-center2"
          />
        </div>
      )}
    </React.Fragment>
  );
};
export default Faq;
